import { FiArrowRight } from "react-icons/fi";
import { FaArrowLeft } from "react-icons/fa6";
import img1 from "../../../../assets/exam/profilesing1.png";
import { Link } from "react-router-dom";
import img2 from "../../../../assets/exam/profilesing2.png";
import img3 from "../../../../assets/exam/profilesing3.png";
import React, { useEffect, useState } from "react";
import { axiosRequest } from "../../../../_config/apiClient";

const TopicPracticeDetail = ({
  selectedTopic,
  onBack,
  selectedExam,
}) => {
  const [practiceLevels, setPracticeLevels] = useState([]);

  useEffect(() => {
    if (!selectedTopic?._id) return;

    fetchPracticeLevels(selectedTopic._id);
  }, [selectedTopic]);

  const fetchPracticeLevels = async (paperId) => {
    try {
      const res = await axiosRequest(
        "post",
        "/user/getPracticeLevels",
        { sourceId: paperId },
        {
          Authorization: `Bearer ${localStorage.getItem("user")}`,
        },
      );

      setPracticeLevels(res.data || []);
    } catch (err) {
      console.error("Get practice levels error", err);
      setPracticeLevels([]);
    }
  };

  const handleStartPractice = (level) => {
    console.log("Starting practice level:", level);
    const examConfig = {
      sourceType: "Practice",
      testName: selectedExam?.name || level?.sectionName || "Practice Test",
      durationMinutes: level.duration || 20,
      totalQuestions: level.totalQuestions,
      guildelines: level.sourceId.guildelines,
      _id: level.sourceId?._id,
    };

    sessionStorage.setItem("examConfig", JSON.stringify(examConfig));
  };


  return (
    <div className="animate-in fade-in duration-500 md:px-0">
      {/* Hero Section - Same as before */}
      <div className="w-full bg-[#F0FFF4] shadow-[0_0px_4px_#00000040] rounded-[10px] p-5 md:p-8 mb-6 md:mb-10">
        <button
          onClick={onBack}
          className="flex items-center gap-2 text-[#4096F6CC] text-[13px] md:text-[14px] font-[500] mb-4 md:mb-6 hover:underline font-inter"
        >
          <FaArrowLeft /> Back to Topics
        </button>

        <h2 className="text-[22px] md:text-[28px] font-[500] text-[#000] tracking-tight font-inter mb-1">
          {selectedTopic?.paperName || "Practice"}
        </h2>
        <p className="text-[13px] md:text-[14px] text-[#000000] font-inter">
          Practice Questions
        </p>
      </div>

      <h3 className="text-[16px] md:text-[18px] font-[500] text-[#333] mb-4 md:mb-5 font-inter">
        Practice Levels
      </h3>

      {/* Practice Levels */}
      <div className="flex flex-col gap-4 md:gap-6">
        {practiceLevels.map((level) => (
          <div
            key={level.id}
            className="bg-white border border-[#E0E0E0] rounded-[10px] overflow-hidden shadow-sm"
          >
            {/* Card Header */}
            <div className="bg-[#DCDCDC] px-4 py-2 text-[12px] md:text-[14px] text-[#000000] font-inter">
              {selectedTopic?.paperName || "Paper"} | Previous Year Qs.
            </div>

            {/* Card Body */}
            <div className="p-4 md:p-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 md:gap-6 w-full">
                {/* Logo with Dynamic First Letter */}
                <div className="w-[50px] h-[50px] md:w-[64px] md:h-[64px] bg-[#4096F6] rounded-[8px] flex items-center justify-center text-white text-[24px] md:text-[32px] font-bold uppercase">
                  {level.sectionName?.charAt(0) || "P"}
                </div>

                <div className="flex flex-col gap-3 md:gap-6 w-full">
                  <div className="flex items-center gap-3 flex-wrap">
                    <span className="bg-[#21C11E] text-white text-[14px] md:text-[16px] font-[500] px-3 py-0.5 rounded-[4px]">
                      Free
                    </span>
                    <h4 className="text-[17px] md:text-[20px] font-[500] text-[#000000] font-inter">
                      {level.sectionName}
                    </h4>
                  </div>

                  <div className="flex flex-col gap-3">
                    <p className="text-[14px] md:text-[16px] text-[#333333B2] font-[500] font-inter">
                      {level.totalQuestions} Practice Questions
                    </p>

                    <div className="flex items-center gap-3">
                      <div className="flex -space-x-3">
                        {[img1, img2, img3].map((img, i) => (
                          <img
                            key={i}
                            src={img}
                            alt="user"
                            className="w-8 h-8 md:w-9 md:h-9 rounded-full border-2 border-white object-cover"
                          />
                        ))}
                      </div>
                      <p className="text-[12px] md:text-[14px] font-[500] text-[#000000]">
                        <span className="font-semibold">{level.completed}</span>{" "}
                        Completed this
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <Link
                to="/exam-instructions"
                onClick={() => handleStartPractice(level)}
                className="flex items-center gap-2 text-[#4096F6] font-[600] text-[14px] md:text-[15px] hover:translate-x-1 transition-transform font-inter"
              >
                Start Practice <FiArrowRight />
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopicPracticeDetail;
